"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableContainer_1 = __importDefault(require("@material-ui/core/TableContainer"));
var Table_1 = __importDefault(require("@material-ui/core/Table"));
var columns_1 = __importDefault(require("../../DataGrid/context/columns"));
var props_1 = __importDefault(require("../context/props"));
var TableHeader_1 = __importDefault(require("../TableHeader"));
var TableBody_1 = __importDefault(require("../TableBody"));
var Table = function (props) { return (react_1.default.createElement(props_1.default, { classes: props.classes },
    react_1.default.createElement(columns_1.default, __assign({}, props),
        react_1.default.createElement(TableContainer_1.default, null,
            react_1.default.createElement(Table_1.default, { "aria-label": "Data table" },
                react_1.default.createElement(TableHeader_1.default, null),
                react_1.default.createElement(TableBody_1.default, { data: props.data })))))); };
exports.default = Table;
